import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-foundation/modal';
import { BsModalRef } from 'ngx-foundation/modal/bs-modal-ref.service';
import { map } from 'rxjs/operators';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  circles = [
    {
      title: '1. Kies het product dat je gaat zoeken.',
      img: 'assets/images/Icon-step1.svg',
      modal: true,
    },
    {
      title:
        '2. Zoek je product en plaats dat binnen 60 tellen in de winkelmand.',
      img: 'assets/images/Icon-step2.svg',
      modal: false,
    },
    {
      title: '3. Bekijk jouw score en daag ook je familie en vrienden uit.',
      img: 'assets/images/Icon-step3.svg',
      modal: false,
    },
  ];

  header1 = 'Ben jij er klaar voor om de uitdaging aan te gaan?';
  header2 = 'Waar kunnen we jouw product heen sturen als jij de winnaar wordt?';

  modalRef: BsModalRef;

  form: FormGroup;
  streetName: string;
  city: string;
  currentStep: 1 | 2;
  callFinished = true;
  isDesktop = false;
  showForm = false;
  formSubmitSending = false;

  constructor(
    private modalService: BsModalService,
    private http: HttpClient,
    private router: Router,
    private userService: UserService
  ) {}

  @HostListener('window:resize')
  onResize() {
    this.isDesktop = window.innerWidth >= 992;
  }

  ngOnInit() {
    document.body.classList.add('intro');
    document.body.classList.remove('game');

    this.isDesktop = window.innerWidth >= 992;

    this.currentStep = 1;
    this.form = new FormGroup(
      {
        firstName: new FormControl('', [
          Validators.required,
          Validators.pattern('^([-a-zA-Z]+[ ]*)+$'),
        ]),
        middleName: new FormControl('', [
          // Validators.required,
          Validators.pattern('^([-a-zA-Z]+[ ]*)+$'),
        ]),
        lastName: new FormControl('', [
          Validators.required,
          Validators.pattern('^([-a-zA-Z]+[ ]*)+$'),
        ]),
        email: new FormControl('', [
          Validators.required,
          Validators.pattern('\\S+@\\S+\\.\\S+'),
        ]),
        allowContact: new FormControl(false),
        zipCode: new FormControl('', [
          // Validators.required,
          Validators.pattern('\\d{4}\\s?[a-zA-Z]{2}'),
        ]),
        houseNumber: new FormControl('', [
          // Validators.required,
          Validators.pattern('\\d+'),
        ]),
        streetName: new FormControl('', [
          Validators.pattern('^([-a-zA-Z0-9]+[ ]*)+$'),
        ]),
        city: new FormControl('', Validators.pattern('^([-a-zA-Z]+[ ]*)+$')),
        houseNumberAdd: new FormControl(
          '',
          Validators.pattern('^([-a-zA-Z0-9]+[ ]*)+$')
        ),
        agreement: new FormControl(false, Validators.requiredTrue),
      },
      [
        (control: FormGroup) => {
          const errors: any = {};
          const { zipCode, houseNumber } = control.controls;
          if (
            (!!zipCode.value && !houseNumber.value) ||
            (!zipCode.value && !!houseNumber.value)
          ) {
            return { invalidAddress: true };
          }

          return errors;
        },
      ]
    );
  }

  openModal(template: TemplateRef<any>, e: MouseEvent, withClass = false) {
    let classString;
    if (withClass) {
      classString = 'longModal';
    } else {
      classString = '';
    }
    this.modalRef = this.modalService.show(template, { class: classString });
    e.preventDefault();
  }

  toStep2() {
    const { firstName, lastName, email, allowContact } = this.form.controls;
    if (
      firstName.valid &&
      lastName.valid &&
      email.valid &&
      allowContact.valid
    ) {
      this.currentStep = 2;
      return;
    } else {
      firstName.markAsTouched({ onlySelf: true });
      lastName.markAsTouched({ onlySelf: true });
      email.markAsTouched({ onlySelf: true });
      allowContact.markAsTouched({ onlySelf: true });
    }
  }

  getFormValid(): boolean {
    return (
      this.form.valid &&
      (!!this.streetName ||
        (this.needExtraInfo() &&
          !!this.form.get('streetName').value &&
          !!this.form.get('city').value) ||
        (!this.form.get('zipCode').value &&
          !this.form.get('houseNumber').value))
    );
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (!this.getFormValid()) {
      return;
    }

    const {
      firstName,
      middleName,
      lastName,
      email,
      houseNumber,
      agreement,
      allowContact,
    } = this.form.value;

    let zipCode = this.form.value.zipCode as string;
    zipCode = zipCode.toUpperCase().replace(' ', '');

    if (zipCode && zipCode.length !== 6) {
      return;
    }
    zipCode = zipCode.substr(0, 4) + ' ' + zipCode.substr(4, 2).toUpperCase();

    const res = {
      firstName,
      middleName,
      lastName,
      email,
      zipCode,
      houseNumber,
      agreement,
      streetName: this.streetName || this.form.get('streetName').value,
      city: this.city || this.form.get('city').value,
      allowContact,
    };

    if (this.form.get('houseNumberAdd').value) {
      // @ts-ignore
      res.houseNumberAddition = this.form.get('houseNumberAdd').value;
    }

    this.formSubmitSending = true;
    this.userService.setUser(res).subscribe(() => {
      this.selectProduct();
    });
  }

  private selectProduct() {
    setTimeout(() => {
      this.formSubmitSending = false;
      this.router.navigate(['/product']);
    }, 100);
  }

  needExtraInfo(): boolean {
    return (
      this.callFinished &&
      this.checkZipCodeValid() &&
      !this.streetName &&
      !this.city
    );
  }

  checkZipCodeValid() {
    return (
      this.form.get('zipCode').value &&
      this.form.get('houseNumber').value &&
      this.form.get('zipCode').valid &&
      this.form.get('houseNumber').valid
    );
  }

  checkZipCode(): void {
    if (!this.checkZipCodeValid()) {
      this.streetName = '';
      this.city = '';
      return;
    }

    const zipCode = this.form.get('zipCode').value;
    const houseNumber = this.form.get('houseNumber').value;

    const params = {
      auth_key: 'oPBmOzJcIJuC9EfG',
      nl_sixpp: zipCode.toUpperCase(),
      streetnumber: houseNumber,
      format: 'json',
      pretty: true,
    };

    if (this.form.get('houseNumberAdd').value) {
      // @ts-ignore
      params.extension = this.form.get('houseNumberAdd').value;
    }

    if (zipCode !== '' && houseNumber !== '') {
      const url = Object.keys(params)
        .map((k) => {
          return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
        })
        .join('&');

      this.callFinished = false;
      this.http
        .get<any>('https://api.pro6pp.nl/v1/autocomplete?' + url)
        .pipe(
          map((res) => {
            if (res.status === 'ok' && res.results) {
              return {
                city: res.results[0].city,
                street: res.results[0].street,
              };
            } else {
              return null;
            }
          })
        )
        .subscribe((res: { city: string; street: string }) => {
          this.callFinished = true;
          if (res) {
            this.streetName = res.street;
            this.city = res.city;
          } else {
            this.streetName = '';
            this.city = '';
          }
        });
    }
  }

  showErrorFor(field: string): boolean {
    const formField = this.form.get(field);

    if (this.formSubmitSending) {
      return false;
    }

    let status = true;

    if (field === 'streetName' || field === 'city') {
      status =
        (formField.touched && !formField.value) ||
        (!this.streetName && !this.city && !this.callFinished);
    } else {
      status = formField.touched && formField.invalid;
    }

    return status;
  }
}
